import { Dispatch } from "react-redux";
import moment from "moment";
import { DELIVERY_WINDOWS } from "constants/action-types";
import { IStore } from "reducers";

export const fetchPredefined = () => ({
    type: DELIVERY_WINDOWS.PREDEFINED.FETCH.START,
    payload: { url: "/delivery/windows" },
});

export const fetchReplenishment = () => (dispatch: Dispatch<{}>, getStore: () => IStore) => {
    const brand = getStore().scope.brand;
    if (
        brand.hasPreference("use_replenishment_delivery_windows") ||
        brand.hasPreference("replenishment_delivery_windows")
    ) {
        // generate preview not to fetch all replenishments
        dispatch({
            type: DELIVERY_WINDOWS.REPLENISHMENT.FETCH.SUCCESS,
            payload: [
                {
                    ship_start: moment().startOf("d").format(),
                    ship_end: moment().add(brand.preferences.get("default_delivery_window"), "d").startOf("d").format(),
                },
            ],
        });
        // return {
        //     type: DELIVERY_WINDOWS.REPLENISHMENT.FETCH,
        //     payload: { url: `/api/v3.0/inventory/delivery-windows` },
        // };
    }
};
